import { useEffect } from 'react';

const useMount = (onMount) => {
	useEffect(onMount, []);
};

export default useMount;
